import {IModalService} from "angular-ui-bootstrap";
import {PlaceOrderWizard} from "../../place-order-wizard/PlaceOrderWizardComponent";
import {BaseStrategy} from "../../types/WhatIf";
import {OptionOrderData} from "../../place-order-wizard/models/OptionOrderData";

export class OptionTicketDialogService {

    public static id = "optionTicketDialogService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public async open(whatIf: BaseStrategy, targetPrice?: number | null, fromTradeIdea = false): Promise<OptionOrderData> {
        const options = {
            component: PlaceOrderWizard,
            size: "lg",
            backdrop: "static",
            resolve: {
                whatIf() {
                    return whatIf;
                },
                fromTradeIdea() {
                    return fromTradeIdea;
                },
                targetPrice() {
                    return targetPrice;
                }
            }
        };
        const modalInstance = this.$uibModal.open(options);
        return modalInstance.result;
    }
}
